'use client'

import Title, { TitleProps } from '@/components/content/common/Title'
import ScrollView from '@/components/ui/ScrollView'

type RowProps = {
  header?: TitleProps
  theme?: 'light' | 'dark'
  children: React.ReactNode
}

export default function Row({ header, theme = 'light', children }: RowProps) {
  return (
    <div className="col-span-2 -ml-3 flex w-[calc(100%+24px)] flex-col gap-5 md:ml-0 md:w-full md:gap-12">
      {header && (
        <div className="px-3 md:px-0">
          <Title {...header} fullWidth={true} />
        </div>
      )}
      <ScrollView className="flex gap-4 px-5 xs:gap-6 md:px-0" theme={theme}>
        {children}
      </ScrollView>
    </div>
  )
}
